/**
 * チャット履歴 API のページサイズ。
 * メモタブから AI チャットのスレッドタイトルを引く際にも同じサイズで取得して、
 * `ChatHistoryList` とクエリキャッシュを共有する。
 */
export const CHAT_HISTORY_PAGE_SIZE = 100;
